import { Component, Input } from "@angular/core";

@Component({
    standalone: false,
    selector: "generator",
    templateUrl: "./generator.view.component.html",
})
export class CodeGenerator {
    @Input() header: string = "";
    @Input() type: string = "";
    private generate: boolean = false;
}
